// Custom next/image loader.
//
// Remote images (DO Spaces, already stored pre-sized) are served DIRECTLY from
// their origin instead of being proxied through `/_next/image`. That keeps them
// off the satranc365.com Cloudflare zone — so they don't count toward the per-IP
// auto-DDoS burst — AND off our origin's image optimizer (which runs on the DO
// instance). A homepage went from ~45 to ~13 zone requests/pageview this way.
//
// Local `/public` images keep the default optimizer (few, already edge-cached).
export default function imageLoader({
    src,
    width,
    quality,
}: {
    src: string;
    width: number;
    quality?: number;
}): string {
    // Remote (Spaces) images and SVGs serve directly — SVGs 400 through the
    // optimizer (needs dangerouslyAllowSVG) and don't need raster optimization.
    if (/^https?:\/\//.test(src) || src.endsWith(".svg")) {
        return src;
    }
    return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}`;
}
